export const openUserSettingsModal = ({
	navigate,
	location,
	userId,
	replace = false,
}) => {
	if (!userId) {
		return false;
	}

	navigate(`/user/${userId}/settings`, {
		replace,
		state: { backgroundLocation: location },
	});

	return true;
};
